import { Component, OnInit, ChangeDetectionStrategy, OnChanges, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs/internal/Subscription';

@Component({
  selector: 'app-notify-user',
  templateUrl: './notify-user.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotifyUserComponent implements OnInit, OnChanges {

    subscription: Subscription;
    incidentId: string;

    constructor(
        public dialogRef: MatDialogRef<NotifyUserComponent>,
        @Inject(MAT_DIALOG_DATA) public data: string
    ) {
        dialogRef.disableClose = true; // Disables default close option
    }

    ngOnInit() {

    }

    ngOnChanges() {

    }

    close() {
        this.dialogRef.close();
    }
}
